<template>
  <div id="ly_hotel_room">
    <div class="page-header">
      <el-page-header @back="$router.back()" :content="`房型管理 - ${hotelName}`" />
      <el-button type="primary" size="small" @click="openRoomDialog()">添加房型</el-button>
    </div>

    <el-table :data="roomList" v-loading="tableLoading" border style="width:100%">
      <el-table-column label="排序" prop="sortNo" width="70" align="center" />
      <el-table-column label="房型名称" prop="name" min-width="150" />
      <el-table-column label="床型" prop="bedType" width="120" />
      <el-table-column label="面积(㎡)" prop="roomArea" width="90" align="center" />
      <el-table-column label="最大入住" prop="maxGuests" width="90" align="center">
        <template slot-scope="{row}">{{ row.maxGuests }}人</template>
      </el-table-column>
      <el-table-column label="含早餐" prop="hasBreakfast" width="80" align="center">
        <template slot-scope="{row}">
          <el-tag size="mini" :type="row.hasBreakfast === 1 ? 'success' : 'info'">
            {{ row.hasBreakfast === 1 ? '含' : '不含' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="价格/晚" prop="price" width="110" align="right">
        <template slot-scope="{row}">
          <span class="util-money">¥{{ row.price }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="80" align="center">
        <template slot-scope="{row}">
          <el-tag size="mini" :type="row.status === 1 ? 'success' : 'info'">
            {{ row.status === 1 ? '可售' : '停售' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" @click="openRoomDialog(row)">编辑</el-button>
          <el-button type="text" style="color:#F56C6C" @click="deleteRoom(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑房型弹窗 -->
    <el-dialog :title="roomForm.id ? '编辑房型' : '添加房型'" :visible.sync="dialogVisible" width="600px">
      <el-form :model="roomForm" :rules="roomRules" ref="roomFormRef" label-width="100px">
        <el-form-item label="房型名称" prop="name">
          <el-input v-model="roomForm.name" placeholder="如：标准大床房" maxlength="50" show-word-limit />
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="价格/晚" prop="price">
              <el-input-number v-model="roomForm.price" :min="0" :precision="2" :step="10" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="床型">
              <el-input v-model="roomForm.bedType" placeholder="如：大床/双床" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="房间面积">
              <el-input-number v-model="roomForm.roomArea" :min="0" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="最大入住">
              <el-input-number v-model="roomForm.maxGuests" :min="1" :max="10" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="含早餐">
              <el-radio-group v-model="roomForm.hasBreakfast">
                <el-radio :label="1">含早</el-radio>
                <el-radio :label="0">不含</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="roomForm.status">
                <el-radio :label="1">可售</el-radio>
                <el-radio :label="2">停售</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序号">
              <el-input-number v-model="roomForm.sortNo" :min="0" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="房间设施">
              <el-input v-model="roomForm.facilities" placeholder="多个用逗号分隔，如：WiFi,空调,浴缸" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saveLoading" @click="saveRoom">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ly_hotel_room",
  data() {
    return {
      hotelId: null,
      hotelName: "",
      tableLoading: false,
      roomList: [],
      dialogVisible: false,
      saveLoading: false,
      roomForm: this.initRoomForm(),
      roomRules: {
        name: [{ required: true, message: "请输入房型名称", trigger: "blur" }],
        price: [{ required: true, message: "请输入价格", trigger: "blur" }],
      },
    };
  },
  created() {
    this.hotelId = this.$route.query.hotelId;
    this.hotelName = this.$route.query.hotelName || "酒店";
    this.loadRooms();
  },
  methods: {
    initRoomForm() {
      return { id: null, hotelId: null, name: "", price: 0, bedType: "", roomArea: 20, maxGuests: 2, hasBreakfast: 0, facilities: "", status: 1, sortNo: 0 };
    },
    async loadRooms() {
      this.tableLoading = true;
      try {
        let { code, data } = await this.$axios.get(`/api/v1/manage/travelHotel/room/${this.hotelId}`);
        if (code === 1) this.roomList = data.list || [];
      } finally {
        this.tableLoading = false;
      }
    },
    openRoomDialog(row) {
      this.roomForm = row ? { ...row } : this.initRoomForm();
      this.roomForm.hotelId = Number(this.hotelId);
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.roomFormRef && this.$refs.roomFormRef.clearValidate());
    },
    saveRoom() {
      this.$refs.roomFormRef.validate(async (valid) => {
        if (!valid) return;
        this.saveLoading = true;
        try {
          let url = "/api/v1/manage/travelHotel/room";
          let { code } = this.roomForm.id
            ? await this.$axios.put(url, this.roomForm)
            : await this.$axios.post(url, this.roomForm);
          if (code === 1) {
            this.$message.success(this.roomForm.id ? "修改成功" : "添加成功");
            this.dialogVisible = false;
            this.loadRooms();
          }
        } finally {
          this.saveLoading = false;
        }
      });
    },
    deleteRoom(row) {
      this.$confirm(`确认删除房型「${row.name}」？`, "删除房型", {
        confirmButtonText: "确认删除", cancelButtonText: "取消", type: "warning"
      }).then(async () => {
        let { code } = await this.$axios.delete("/api/v1/manage/travelHotel/room", { id: row.id });
        if (code === 1) { this.$message.success("删除成功"); this.loadRooms(); }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
#ly_hotel_room {
  padding: 16px;
  .page-header {
    display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;
  }
  .util-money { font-weight: 600; color: #F56C6C; }
}
</style>
